import React from "react";
import { useTranslation } from "react-i18next";
import { useTheme } from "styled-components";
import { TextVariant, TypographyNew } from "../typography/typography";
import { EmployeeAvatarDto } from "../../redux/api-model/organization/company";

type EmployeeAvatarSubTitleProps = {
  position?: string | null;
  personalNr?: EmployeeAvatarDto["personalNr"];
  showPersonalNr?: boolean;
};

export default function EmployeeAvatarSubTitle({
  position,
  personalNr,
  showPersonalNr,
}: EmployeeAvatarSubTitleProps): JSX.Element {
  const { t } = useTranslation("employees");
  const theme = useTheme();

  if (showPersonalNr && personalNr) {
    return (
      <TypographyNew
        noWrap
        variant={TextVariant.caption}
        color={theme.colors.grays3}
        style={{ lineHeight: "15px" }}
      >
        {`#${personalNr}`}
      </TypographyNew>
    );
  }

  return (
    <>
      {position !== null ? (
        <TypographyNew
          noWrap
          variant={TextVariant.caption}
          color={theme.colors.grays3}
          style={{ lineHeight: "15px" }}
        >
          {position}
        </TypographyNew>
      ) : (
        <TypographyNew
          variant={TextVariant.caption}
          color={"error"}
          style={{ lineHeight: "15px" }}
        >
          {t("employees.positionIsMissing")}
        </TypographyNew>
      )}
    </>
  );
}
